import { useEffect, useMemo, useState } from 'react';
import { EuiSideNav, EuiIcon } from '@elastic/eui';
import CESgv from '../../../../../../shared/Icons/CE.svg';
import DGSgv from '../../../../../../shared/Icons/DG.svg';
import SGSgv from '../../../../../../shared/Icons/SG.svg';
import DESgv from '../../../../../../shared/Icons/DE.svg';
import D2Sgv from '../../../../../../shared/Icons/D2.svg';
import DNSgv from '../../../../../../shared/Icons/DN.svg';
import CTSgv from '../../../../../../shared/Icons/CT.svg';

const TipoCentroIcon = (tipo) =>{
  switch (tipo) {
      case 'CE':
          return <EuiIcon type={CESgv} size='l'/>;
      case 'DG':
          return <EuiIcon type={DGSgv} size='l'/>;
      case 'SG':
          return <EuiIcon type={SGSgv} size='l'/>;
      case 'DE':
          return <EuiIcon type={DESgv} size='l'/>;
      case 'D2':
          return <EuiIcon type={D2Sgv} size='l'/>;
      case 'DN':
          return <EuiIcon type={DNSgv} size='l'/>;
      case 'CT':
          return <EuiIcon type={CTSgv} size='l'/>;
  
      default:
          break;
  }
}

export const SumarigramaTreeView = (props) => {

  const {data, search, version, onClickNode} = props;
  const [isSideNavOpenOnMobile, setIsSideNavOpenOnMobile] = useState(false);
  const [selectedItemName, setSelectedItem] = useState(null);

  useEffect(()=>{
    search && selectItem(search)
  },[search])

  useEffect(()=>{
    const elm = document.getElementsByClassName('TreeviewItem'+search);
    if(elm!==undefined && elm.length>0)elm[0].scrollIntoView();
  },[selectedItemName])

  const toggleOpenOnMobile = () => {
    setIsSideNavOpenOnMobile(!isSideNavOpenOnMobile);
  };

  const selectItem = (id) => {
    onClickNode && onClickNode(id)
    setSelectedItem(id);
  };

  const createItem = (item) => {
    return {
    className:'TreeviewItem'+item.id,
    id: item.id,
    name: item.id === null ? item.name : `${item.id} - ${item.descripcion}`,
    icon: TipoCentroIcon(item.tipo),
    items: item.hijos.map((d) => createItem(d)),
    forceOpen: item.id === null,
    disabled: item.id === null,
    isSelected: selectedItemName === item.id,
    onClick: () => selectItem(item.id),
    };
  };

  const sideNav =  data && [createItem({id:null, name:(version ? `Sumarigrama Versión ${version}` : ''), hijos:data.jerarquia})]

  return (
        <EuiSideNav
        aria-label="Force-open example"
        mobileTitle="Navigate within $APP_NAME"
        toggleOpenOnMobile={toggleOpenOnMobile}
        isOpenOnMobile={isSideNavOpenOnMobile}
        items={sideNav}
        />
  );
};